import { FC } from 'react'
import { useGetTranslations } from '@/root/shared-hooks'
import { RefundAgreementProps } from '@/root/shared-types'
import { Banner, Checkbox } from '@/root/ui/tuuleliinid'

export const RefundAgreement: FC<RefundAgreementProps> = ({ isAgreementAccepted, onAcceptAgreement }) => {
  const { getTranslation } = useGetTranslations()
  return (
    <div>
      <Banner variant="neutral" className="text-left">
        <p className="">{getTranslation('amountRefundTip')}</p>
      </Banner>
      <Checkbox
        label={getTranslation('refundAgreement')}
        checked={isAgreementAccepted}
        onChange={onAcceptAgreement}
        variant="error"
        className="mt-8 gap-2"
      />
    </div>
  )
}
